import { Pipe, PipeTransform, signal } from '@angular/core';
import { Dictionary } from '@softline/core';
import { translator } from '../functions/translator.function';

@Pipe({
  name: 'translate',
  pure: false,
})
export class TranslatePipe implements PipeTransform {
  private prevValue: (string | { message: string; params: Dictionary<unknown> }) | null =
    null;
  private state = signal<string | null>(null).asReadonly();

  private t = translator();

  transform(
    value: (string | { message: string; params: Dictionary<unknown> }) | undefined | null
  ): string | null | undefined {
    if (!value) return value;

    if (this.prevValue !== value) {
      // This must be untracked because we want to create signals inside of template execution.
      if (typeof value === 'string') {
        this.state = this.t(value);
        this.prevValue = value;
      } else {
        this.state = this.t(value.message, value.params);
        this.prevValue = value;
      }
    }
    return this.state();
  }
}
